import { RouteEnum } from '@/models/route/Route.model.ts';

export type LeftNavigationBarTranslation = {
  [RouteEnum.ADMINISTRATION]: string;
  [RouteEnum.CALENDAR]: string;
  [RouteEnum.CARS]: string;
  [RouteEnum.CATALOG]: string;
  [RouteEnum.CHATS]: string;
  [RouteEnum.CONTACTS]: string;
  [RouteEnum.CUSTOMERS]: string;
  [RouteEnum.DASHBOARD]: string;
  [RouteEnum.DICTIONARIES]: string;
  [RouteEnum.EMAILS]: string;
  [RouteEnum.EMERGENCY_CONTACTS]: string;
  [RouteEnum.HR]: string;
  [RouteEnum.OFFERS]: string;
  [RouteEnum.PROCESSES]: string;
  [RouteEnum.REPORTS]: string;
  [RouteEnum.SETTLEMENTS]: string;
  [RouteEnum.STATISTICS]: string;
  [RouteEnum.SUPPLIERS]: string;
  [RouteEnum.TASKS]: string;
  [RouteEnum.USERS]: string;
};

export const leftNavigationBarTranslation: LeftNavigationBarTranslation = {
  [RouteEnum.ADMINISTRATION]: 'Administracja',
  [RouteEnum.CALENDAR]: 'Kalendarz',
  [RouteEnum.CARS]: 'Auta',
  [RouteEnum.CATALOG]: 'Katalog',
  [RouteEnum.CHATS]: 'Czaty',
  [RouteEnum.CONTACTS]: 'Kontakty',
  [RouteEnum.CUSTOMERS]: 'Klienci',
  [RouteEnum.DASHBOARD]: 'Start',
  [RouteEnum.DICTIONARIES]: 'Słowniki',
  [RouteEnum.EMAILS]: 'Poczta',
  [RouteEnum.EMERGENCY_CONTACTS]: 'Kontakty awaryjne',
  [RouteEnum.HR]: 'Kadry',
  [RouteEnum.OFFERS]: 'Oferty',
  [RouteEnum.PROCESSES]: 'Procesy',
  [RouteEnum.REPORTS]: 'Raporty',
  [RouteEnum.SETTLEMENTS]: 'Rozliczenia',
  [RouteEnum.STATISTICS]: 'Statystyki',
  [RouteEnum.SUPPLIERS]: 'Dostawcy',
  [RouteEnum.TASKS]: 'Zadania',
  [RouteEnum.USERS]: 'Konta',
};
